import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import { ProductCardComponent } from '../../../../shared/ui/product-card/product-card.component';
import { CategoryService } from '../../../../core/services/category.service';
import { ProductService } from '../../../../core/services/product.service';

@Component({
  selector: 'app-categoria',
  standalone: true,
  imports: [NgIf, NgFor, ProductCardComponent],
  templateUrl: './categoria.component.html',
  styleUrl: './categoria.component.scss'
})
export class CategoriaComponent {
  private route = inject(ActivatedRoute);
  private cs = inject(CategoryService);
  private ps = inject(ProductService);

  slug = this.route.snapshot.paramMap.get('slug')!;
  cat = this.cs.getBySlug(this.slug);
  items = this.ps.byCategory(this.slug);
}
